import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAmplitude } from '../hooks/useAmplitude';

interface AmplitudeTrackerProps {
  children: React.ReactNode;
}

export const AmplitudeTracker: React.FC<AmplitudeTrackerProps> = ({ children }) => {
  const location = useLocation();
  const { trackPage } = useAmplitude();

  // Track page views automatically
  useEffect(() => {
    trackPage(location.pathname, {
      page_title: document.title,
      referrer: document.referrer,
    });
  }, [location.pathname, trackPage]);

  return <>{children}</>;
};

// Example component showing how to track user interactions
export const TrackedButton: React.FC<{
  onClick?: () => void;
  children: React.ReactNode;
  actionName: string;
  properties?: Record<string, any>;
}> = ({ onClick, children, actionName, properties }) => {
  const { trackAction } = useAmplitude();

  const handleClick = () => {
    trackAction(actionName, properties);
    onClick?.();
  };

  return (
    <button onClick={handleClick}>
      {children}
    </button>
  );
}; 